export enum ShippingDocumentTypes {
  Dox = 'dox',
  NDox = 'ndox',
}
